import { IRequest } from "interfaces/models/IRequest";
import IUserApplicationDetails from "interfaces/models/IUserApplicationDetails";

const mapRequestToUserApplicationDetails = (request : IRequest) : IUserApplicationDetails => {
  const userApplicationDetails : IUserApplicationDetails = {
    applicationDetails: {
      applicationId: request.applicationId,
      applicationType: request.applicationType!,
      environment: "",
      siteUrl: request.site
    },
    isAllocated: false
  };

  return userApplicationDetails;
};

export { mapRequestToUserApplicationDetails };
